import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { FieldTypeIndicatorField, fieldTypeIndicatorOf } from './field-type-presentation';

export type FieldTypeIndicatorVariant = 'outlined' | 'soft';
export type FieldTypeIndicatorSize = 'sm' | 'md' | 'lg';
export type FieldTypeIndicatorOrientation = 'horizontal' | 'vertical';

@Component({
  selector: 'cipo-field-type-indicator',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './field-type-indicator.component.html',
  styleUrl: './field-type-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-variant]': 'variant()',
    '[attr.data-size]': 'size()',
    '[attr.data-orientation]': 'orientation()',
    '[style.--indicator-color]': 'indicatorColor()',
    '[style.--indicator-border]': 'indicatorBorder()',
    '[style.--indicator-background]': 'indicatorBackground()',
  },
})
export class FieldTypeIndicatorComponent {
  readonly field = input.required<FieldTypeIndicatorField>();
  readonly variant = input<FieldTypeIndicatorVariant>('outlined');
  readonly size = input<FieldTypeIndicatorSize>('md');
  readonly orientation = input<FieldTypeIndicatorOrientation>('horizontal');
  readonly color = input<string>();
  readonly bgColor = input<string>();
  readonly showIcon = input(true);
  readonly showDisplayType = input(true);

  readonly presentation = computed(() => fieldTypeIndicatorOf(this.field()));
  readonly indicatorColor = computed(() => this.color() || 'var(--black-700)');
  readonly indicatorBorder = computed(() => this.color() || 'var(--black-300)');
  readonly indicatorBackground = computed(() => {
    if (this.bgColor()) {
      return this.bgColor();
    }
    if (this.variant() === 'outlined') {
      return 'transparent';
    }
    return this.color() ? `color-mix(in srgb, ${this.color()} 10%, var(--white))` : 'var(--black-100)';
  });
}
